module.exports = __webpack_public_path__ + "static/media/carter1.fc2f1d21.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/carter/images/carter1.jpg
// module id = 89
// module chunks = 0